import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import { useEffect, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import AccountInfoTab from "./Tabs/AccountInfoTab";
import ProfileInfoTab from "./Tabs/ProfileInfoTab";
import CareerTab from "./Tabs/CareerTab";
import WorkConditionTab from "./Tabs/WorkConditionTab";
import userApi from "api/userApi";

export interface Props {
  isOpen: boolean;
  item?: any;
  regions?: any;
  setLinkImage?: any;
  triggerRefresh?: () => void;
  onClose?: () => void;
}

registerLocale("en", en);
registerLocale("ko", ko);

const UserDetail = ({ isOpen, item, regions, setLinkImage, triggerRefresh, onClose }: Props) => {
  const { t, i18n } = useTranslation();
  const [activeTab, setActiveTab] = useState("ACCOUNT_INFO");
  const [dataProfile, setDataProfile] = useState<any>(null);
  
  const tabChange = (tab: any) => {
    if (activeTab !== tab) {
      setActiveTab((_prev) => tab);
    }
  };

  const onCloseClick = () => {
    setActiveTab('ACCOUNT_INFO');
    onClose && onClose();
  };

  const handleUpdateSuccess = async (type?: string) => {
    if(!item?.id) return;

    try {
      const response: any = await userApi.getUser(item?.id);
      if(response?.data) {
        setDataProfile(response?.data)
      }
    }catch(error) {
      console.log(error)
    }
    if(type !== "noRefresh") {
      triggerRefresh && triggerRefresh();
    }
  }

  const isGuest = () => {
    if(dataProfile?.user_device?.login_type === 'GUEST') return true;

    return false;
  }

  useEffect(() => {
    if(item) {
      handleUpdateSuccess("noRefresh")
    }
  }, [item])

  return (
    <Modal isOpen={isOpen} centered={true} size="xl" scrollable={true}>
      <ModalHeader toggle={onCloseClick}>{`${t("Detail User")} ${item?.email ? '-'  : ""} ${item?.email || ""}` }</ModalHeader>
      <ModalBody className="pt-0">
        <div style={{ minHeight: "calc(100dvh - 200px)" }}>
          <Col lg={12}>
            <Card
              id="ACCOUNT_INFO"
              style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)", borderTop: "unset" }}
            >
              <div
                style={{
                  background: "#f3f6f9",
                  borderTopLeftRadius: "0.6rem",
                  borderTopRightRadius: "0.6rem",
                  position: "sticky",
                  top: "0px",
                  zIndex: 99,
                  borderTop: "1px solid #e9ebec"
                }}
              >
                <div
                  className="d-block"
                  style={{
                    background: "#f3f6f9",
                    borderRadius: "0.6rem",
                    width: "fit-content",
                  }}
                >
                  <Nav
                    tabs
                    className="nav nav-tabs nav-link-none-hover nav-justified"
                  >
                    <NavItem style={{ minWidth: "120px" }}>
                      <NavLink
                        style={{
                          cursor: "pointer",
                          background: `${
                            activeTab === "ACCOUNT_INFO"
                              ? "var(--vz-primary)"
                              : "unset"
                          }`,
                          color: `${
                            activeTab === "ACCOUNT_INFO" ? "white" : "unset"
                          }`,
                          borderTopRightRadius: 0,
                        }}
                        onClick={() => tabChange("ACCOUNT_INFO")}
                      >
                        {t("Account Info")}
                      </NavLink>
                    </NavItem>
                    <NavItem style={{ minWidth: "100px" }}>
                      <NavLink
                        style={{
                          cursor: `${
                            isGuest() ? "default" : "pointer"
                          }`,
                          background: `${
                            activeTab === "PROFILE_INFO"
                              ? "var(--vz-primary)"
                              : "unset"
                          }`,
                          color: `${
                            activeTab === "PROFILE_INFO" ? "white" : (isGuest() ? "gray" : "unset")
                          }`,
                          borderTopLeftRadius: 0,
                          borderTopRightRadius: 0,
                        }}
                        onClick={() => {
                          if(isGuest()) return;

                          tabChange("PROFILE_INFO")
                        }}
                      >
                        {t("Profile Info")}
                      </NavLink>
                    </NavItem>
                    <NavItem style={{ minWidth: "140px" }}>
                      <NavLink
                        style={{
                          cursor: `${
                            isGuest() ? "default" : "pointer"
                          }`,
                          background: `${
                            activeTab === "WORK_CONDITION"
                              ? "var(--vz-primary)"
                              : "unset"
                          }`,
                          color: `${
                            activeTab === "WORK_CONDITION" ? "white" : (isGuest() ? "gray" : "unset")
                          }`,
                          borderTopLeftRadius: 0,
                          borderTopRightRadius: 0,
                        }}
                        onClick={() => {
                          if(isGuest()) return;

                          tabChange("WORK_CONDITION")
                        }}
                      >
                        {t("Work Condition")}
                      </NavLink>
                    </NavItem>
                    <NavItem style={{ minWidth: "140px" }}>
                      <NavLink
                        style={{
                          cursor: `${
                            isGuest() ? "default" : "pointer"
                          }`,
                          background: `${
                            activeTab === "CAREER"
                              ? "var(--vz-primary)"
                              : "unset"
                          }`,
                          color: `${
                            (activeTab === "CAREER") ? "white" : (isGuest() ? "gray" : "unset")
                          }`,
                          borderTopLeftRadius: 0,
                          borderTopRightRadius: 0,
                        }}
                        onClick={() => {
                          if(isGuest()) return;

                          tabChange("CAREER")
                        }}
                      >
                        {t("Career")}
                      </NavLink>
                    </NavItem>
                  </Nav>
                </div>
              </div>
              <TabContent activeTab={activeTab}>
                <TabPane tabId="ACCOUNT_INFO">
                  {activeTab === "ACCOUNT_INFO" && (
                    <AccountInfoTab data={dataProfile} handleUpdateSuccess={handleUpdateSuccess} setLinkImage={setLinkImage} />
                  )}
                </TabPane>
                <TabPane tabId="PROFILE_INFO">
                  {activeTab === "PROFILE_INFO" && (
                    <ProfileInfoTab data={dataProfile} handleUpdateSuccess={handleUpdateSuccess} setLinkImage={setLinkImage} />
                  )}
                </TabPane>
                <TabPane tabId="WORK_CONDITION">
                  {activeTab === "WORK_CONDITION" && (
                    <WorkConditionTab data={dataProfile} regions={regions} handleUpdateSuccess={handleUpdateSuccess} setLinkImage={setLinkImage} />
                  )}
                </TabPane>
                <TabPane tabId="CAREER">
                  {activeTab === "CAREER" && (
                    <CareerTab data={dataProfile} handleUpdateSuccess={handleUpdateSuccess} />
                  )}
                </TabPane>
              </TabContent>
            </Card>
          </Col>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default UserDetail;
